module.exports = __webpack_public_path__ + "img/check-list-active.c71027fe.svg";